import React from 'react';
import { Route, IndexRoute } from 'react-router';

import { App, Home, NotFound } from './components/App.js';
import { SingleVideo } from './components/SingleVideo.js';

export const routes = (
  <Route path='/' component={App}>
    <IndexRoute title='Stein Family Videos' component={Home} />
    <Route path='/video/:videoId' title='Stein Family Videos' component={SingleVideo} />
    <Route path='*' title='404: Not Found' component={NotFound} />
  </Route>
);

export default routes;



// WEBPACK FOOTER //
// ./client/routes.js